export default class DateUtils {
  public static getShortTimeString(date: Date) {
    return `${("0" + date.getHours()).slice(-2)}:${(
      "0" + date.getMinutes()
    ).slice(-2)}:${("0" + date.getSeconds()).slice(-2)}`;
  }

  public static getShortDateTimeString(date: Date) {
    return `${date.toDateString()} ${this.getShortTimeString(date)}`;
  }
}
